import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";

import type {
  GetMaximalPower,
  MaximalPower,
} from "@services/apiEcms/apiEcms.types";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

const columnHelper = createColumnHelper<GetMaximalPower>();

export const usePerimeterSiteMaxPowerColumns = () => {
  const { t } = useCustomTranslation(["main", "common"]);

  const columns = useMemo(() => {
    const getMaximalPowerLabel = (maximalPower?: MaximalPower | null) => {
      if (!maximalPower?.maximalPower)
        return t("missingData", { ns: "common" });

      return maximalPower.date
        ? t("perimeter.sites.maximalPower.label", {
            value: maximalPower.maximalPower,
            date: new Date(maximalPower.date),
          })
        : t("numberWithUnit", {
            ns: "common",
            value: maximalPower.maximalPower,
            measurementUnit: "kVA",
          });
    };

    return [
      columnHelper.accessor("weekMaximalPower", {
        header: t("perimeter.sites.maximalPower.columns.week"),
        enableSorting: false,
        cell: ({ getValue }) => getMaximalPowerLabel(getValue()),
        meta: { align: "center" },
      }),
      columnHelper.accessor("monthMaximalPower", {
        header: t("perimeter.sites.maximalPower.columns.month"),
        enableSorting: false,
        cell: ({ getValue }) => getMaximalPowerLabel(getValue()),
        meta: { align: "center" },
      }),
      columnHelper.accessor("yearMaximalPower", {
        header: t("perimeter.sites.maximalPower.columns.year"),
        enableSorting: false,
        cell: ({ getValue }) => getMaximalPowerLabel(getValue()),
        meta: { align: "center" },
      }),
    ];
  }, [t]);

  return columns;
};
